<div class="modal-header">
	<button type="button" class="close close-button" aria-label="Close" mat-dialog-close="Cross click">
		<fa-icon [icon]="['fal', 'times']"></fa-icon>
	</button>
</div>
<div class="modal-body">
	<form name="ScheduleNewScan" class="schedulenewscan-modal" (submit)="onNewScanScheduling()" novalidate>
	</form>

	<div class="recurrence">{{recurrence}}</div>

	<div class="warning">{{warning}}</div>

	<div class="subname">{{interval}}</div>

	<mat-form-field appearance="fill-customize">
		<mat-select disableOptionCentering=true (selectionChange)="updateSelectedFrequency($event)">
			<mat-option *ngFor="let option of optionsInterval" [value]="option.name">
				{{ option.name }}
			</mat-option>
		</mat-select>
	</mat-form-field>

	<div class="subname">{{dateToken}}</div>

	<div>
		<mat-form-field appearance="fill-customize">
			<mat-label>{{pickDate}}</mat-label>
			<input matInput [matDatepicker]="picker" [value]="date" (dateChange)="onDateSelect($event)">
			<mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
			<mat-datepicker #picker></mat-datepicker>
		</mat-form-field>
	</div>

	<div class="subname">{{time}}</div>

	<div class="time">
		<mat-form-field appearance="fill-customize" floatLabel="never">
			<mat-label>{{hours}}</mat-label>
			<mat-select disableOptionCentering=true (selectionChange)="updateSelectedHour($event)">
				<mat-option *ngFor="let option of optionsInterval" [value]="option.name">
					{{ option.name }}
				</mat-option>
			</mat-select>
		</mat-form-field>
		<mat-form-field appearance="fill-customize" floatLabel="never" class="px-3">
			<mat-label>{{minutes}}</mat-label>
			<mat-select disableOptionCentering=true (selectionChange)="updateSelectedMinute($event)">
				<mat-option *ngFor="let option of optionsHours" [value]="option.name">
					{{ option.name }}
				</mat-option>
			</mat-select>
		</mat-form-field>
		<mat-form-field appearance="fill-customize" floatLabel="never">
			<mat-label>{{ampm}}</mat-label>
			<mat-select disableOptionCentering=true (selectionChange)="updateSelectedAMPM($event)">
				<mat-option *ngFor="let option of optionsInterval" [value]="option.name">
					{{ option.name }}
				</mat-option>
			</mat-select>
		</mat-form-field>
	</div>

	<div>
		<div class="subname">{{typeOfScan}}</div>

		<div class="radiobutton">
			<label class="radiobtn" for="quick">{{quickScan}}
				<input type="radio" id="quick" name="scantype" value="quick" (change)="onScanOptionChange('0')">
				<div class="checkmark"></div>
			</label>

			<label class="radiobtn" for="full">{{fullScan}}
				<input type="radio" id="full" name="scantype" value="full" (change)="onScanOptionChange('1')">
				<div class="checkmark"></div>
			</label>
		</div>
	</div>

	<br />

	<div class="row">
		<div class="col buttons">
			<vtr-material-button
				[label]="scheduleNewScanButtonText | uppercase"
				[isDisabled]="disable"
				[tooltipText] ="scheduleNewScanButtonText"
				(buttonClick)="onNewScanScheduling()"
				heightSize="lg">
			</vtr-material-button>

			<a *ngIf="editMode" class="action-anchor" (click)="onDeleteScan()">{{ delete }}</a>
		</div>

	</div>
</div>
